import {
  Component, AfterViewInit, ViewChildren, ElementRef, QueryList, ViewChild
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApiService } from '../../api/api.service';
import { AuthService } from '../../auth/auth.service';
import { UIRouter } from '@uirouter/core';

export interface FaqEntryInterface {
  title: string;
  content: string;
}

@Component({
  styleUrls: ['./faq.component.scss'],
  templateUrl: './faq.component.html'
})
export class PageFaqComponent implements AfterViewInit {
  /* tslint:disable */
  public entries: FaqEntryInterface[] = [
    {
      title: 'Wie kann ich spenden?',
      content: 'Indem du dir auf dieser Homepage deinen eigenen digitalen Knopf holst und einen von dir frei ausgewählten Betrag spendest.'
    },
    {
      title: 'Kann ich anonym spenden?',
      content: `Ja, Du kannst in Deinem Profil einstellen, ob Du anonym auftrittst oder ob dein Vorname und der erste Buchstabe deines Nachnamens öffentlich sichtbar ist. Alle anderen Daten werden nicht veröffentlicht.`
    },
    {
      title: 'Wie kann ich meine Spende begleichen?',
      content: `Du kannst deine Spende aktuell per Kreditkarte oder Paypal begleichen. Wir arbeiten aber daran, dass es zeitnah auch per Lastschrift geht. Möchtest Du momentan per Überweisung spenden, kontaktiere uns bitte über unser <a href="/faq#kontakt">Kontaktformular</a> "Frage zur Spende".`
    },
    {
      title: 'Was kann ich mit meinem digitalen Knopf machen?',
      content: `Deinem digitalen Knopf kannst du einen Wert widmen, der dir besonders wichtig ist, z.B. Mut, Dankbarkeit, Kind in dir, Freiheit.
        Außerdem hast du die Möglichkeit, für deinen Knopf ein bestimmtes Design zu wählen. Deinen persönlichen Knopf
        kannst du über alle gängigen sozialen Netzwerke teilen und herzeigen.`
    },
    {
      title: 'Kann ich auch einen Knopf verschenken?',
      content: `Ja, das geht und wir würden uns sogar sehr freuen, wenn du das tust. Du kannst einfach Knöpfe hinzufügen und dann die E-Mail-Adresse des Beschenkten angeben. Wir senden dann eine E-Mail direkt an den Beschenkten, über die er selbst Zugriff auf den digitalen Knopf bekommt.`
    },
    {
      title: 'Was ist ein Gutschein-Code?',
      content: `Wenn du einen Gutschein-Code hast, hat dir jemand einen Knopf geschenkt. Diesen kannst du einlösen, deinen persönlichen Knopf auswählen und ihn mit deiner Community teilen.`
    },
    {
      title: 'Wie kann ich als Unternehmen aktiv werden?',
      content: `Wenn du als Unternehmen für einen Teil oder auch alle deiner Mitarbeiter:innen spenden und einen digitalen Knopf erhalten möchtest, kontaktiere uns bitte über unser <a href="/faq#kontakt">Kontaktformular</a> "als Unternehmen aktiv werden".`
    },
    {
      title: 'Was geschieht mit den Spendengeldern?',
      content: `<p>Die Spendengelder fließen in unsere Zentren der Phantasie. Dort werden Kinder und Jugendliche in Afrika und Deutschland Teil eines großen Abenteuers. In spielerischen Herausforderungen und Aktionen lernen sie, wie man durch positives Verhalten zum Held seines eigenen Lebens und zum Held für andere werden kann.</p>
        <p>Die eingenommenen Spenden werden nicht für Verwaltungstätigkeiten der Jim Button Foundation verwendet. Verwaltungstätigkeiten und administrative Aufgaben werden ausschließlich aus Geldern finanziert, die explizit für solche Zwecke gegeben wurden.</p>`
    },
    {
      title: 'Wie erhalte ich eine Spendenquittung?',
      content: `Bei einer Spende ab € 200 bietet dir das System automatisch an, eine steuerlich absetzbare Spendenquittung per  Mail zu bekommen. Bis € 200  genügt zur steuerlichen Absetzbarkeit der Überweisungsbeleg.`
    },
    {
      title: 'Wer steht hinter der Mut zur Phantasie Kampagne?',
      content: `Initiator und verantwortlich für die „Mut zur Phantasie“ Kampagne ist die gemeinnützige Stiftung
        <a href="/jim-button-foundation">„Jim Button Foundation“</a>.`
    }
  ];
  /* tslint:enable */

  @ViewChildren('cardBodyElement')
  public cardBodyElements: QueryList<ElementRef>;
  @ViewChild('contactNameInput')
  public contactNameInput;
  @ViewChild('contactEmailInput')
  public contactEmailInput;
  @ViewChild('contactFormSubmitButton')
  public contactFormSubmitButton;
  
  private contactFormSubmitButtonOrigVal: string = '';

  public activeIndex: number = 0;
  public activeHeight: number = 0;

  public isSuccess: boolean = false;
  public isLoggedIn: boolean = false;
  public formIsSending: boolean = false;

  public contactData = {
    name: null,
    email: null,
    subject: null,
    message: null
  };

  public subjectOptions = {
    'Allgemein': 'Allgemein',
    'Frage zur Spende': 'Frage zur Spende',
    'Presseanfrage': 'Presseanfrage',
    'technische Frage': 'technische Frage',
    'Spendenquittung anfordern': 'Spendenquittung anfordern',
    'als Unternehmen aktiv werden': 'als Unternehmen aktiv werden'
  };

  constructor(
    private router: UIRouter,
    private apiService: ApiService,
    private authService: AuthService
  ) { }
  
  public ngOnInit() {
    this.isLoggedIn = !!this.authService.currentUser;
    
    this.authService.currentUserChange.subscribe(
      (result) => {
        this.isLoggedIn = !!result;
        this.setUserData(result);
      }
    );
  }
  
  private setUserData(user) {    
    if (this.isLoggedIn) {
      this.contactData.name = `${user.firstName} ${user.lastName}`;
      this.contactData.email = user.email;
    } else {
      if (this.contactData.name !== null) {
        this.contactNameInput.value = '';
      }
      
      if (this.contactData.email !== null) {
        this.contactEmailInput.value = '';
      }
    }
  }

  public ngAfterViewInit() {
    setTimeout(() => {
      this.activeHeight = this.cardBodyElements.first.nativeElement.offsetHeight;
      this.setUserData(this.authService.currentUser);
    });
  }

  public setActive(index: number, cardBodyElement, card) {    
    if (this.activeIndex === index) {
      this.activeIndex = -1;
    } else {
      this.activeIndex = index;
      
      setTimeout(() => {
        this.activeHeight = cardBodyElement.offsetHeight;
        setTimeout(() => {
          let elementPositionTop = card.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
          
          scrollTo({
            top: elementPositionTop - 40,
            behavior: 'smooth',
          });
        }, 200);
      });
    }
  }

  public handleSubmit(form: NgForm) {
    if (form.valid) {
      const data = {
        name: this.contactData.name,
        email: this.contactData.email,
        topic: this.contactData.subject,
        message: this.contactData.message,
      };
      
      this.contactFormSubmitButtonOrigVal = this.contactFormSubmitButton.nativeElement.value;
      this.contactFormSubmitButton.nativeElement.value = 'Wird gesendet';
      this.formIsSending = true;

      this.apiService.post('contact/send', data)
        .subscribe(
          (result) => {
            this.isSuccess = true;
            this.contactFormSubmitButton.nativeElement.value = this.contactFormSubmitButtonOrigVal;
            this.formIsSending = false;
          }
        );
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/pages/faq/faq.component.ts